import { render, staticRenderFns } from "./TutorEditTabSocial.vue?vue&type=template&id=13819ce2&"
import script from "./TutorEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./TutorEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports